import apiClient from './apiClient';

console.warn('API endpoints for Contacts are not defined in README.md. Using placeholder functions.');

export const getContacts = (is_deleted) => {
  return apiClient('/contacts?is_deleted='+is_deleted);
};

export const createContact = (contactData) => {
  return apiClient('/contacts', { body: contactData, method: 'POST' });
};

export const updateContact = (contactId, contactData) => {
  return apiClient(`/contacts/${contactId}`, { body: contactData, method: 'PUT' });
};

export const deleteContact = (contactId, toArhive = true) => {
  return apiClient(`/contacts/${contactId}`, { body: {"archiveState": toArhive}, method: 'DELETE' });
}; 